import { createApp } from 'vue';

import designSystem from '@docx-io/design-system';

import router from './pages/routes';
import App from './App.vue';
import Components from './components';
import store from './store';

const app = createApp(App);

app.use(store);
app.use(router);
app.use(designSystem);
Components.setup(app);

app.config.productionTip = false;

app.mount('#app');
